import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL || 'http://localhost:3001'}/api/auth/login`, {
        email,
        password,
      });
      if (response.data && response.data.token) {
        localStorage.setItem('token', response.data.token);
        setMessage('Sikeres bejelentkezés! Üdvözlünk!');
        setTimeout(() => navigate('/wizard'), 1500);
      } else {
        setMessage('Ismeretlen hiba.');
      }
    } catch (error) {
      setMessage(
        error.response?.data?.error ||
          'Hiba történt a bejelentkezés során. Ellenőrizd az email címet, jelszót, vagy hogy megerősítetted-e az email címed!'
      );
    }
  };

  return (
    <div>
      <h2>Bejelentkezés</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Jelszó"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <button type="submit">Bejelentkezés</button>
      </form>
      {message && <div style={{ marginTop: '1em', color: message.startsWith('Sikeres') ? 'green' : 'red' }}>{message}</div>}
    </div>
  );
};

export default Login;
